import type { Reducer } from 'redux';

import { LOGOUT_SUCCESS } from 'features/auth/redux/types';
import { DashboardActions } from 'features/dashboard/redux//actions';
import {
  BULK_EMAIL_VALIDATION_FAILED,
  BULK_EMAIL_VALIDATION_REQUEST,
  BULK_EMAIL_VALIDATION_SUCCESS,
  CLEAR_ORDERS_STATE,
  CREATE_BULK_ORDER_FAILED,
  CREATE_BULK_ORDER_REQUEST,
  CREATE_BULK_ORDER_SUCCESS,
  CREATE_ORDER_FAILED,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  UPLOAD_BULK_ORDER_FAILED,
  UPLOAD_BULK_ORDER_REQUEST,
  UPLOAD_BULK_ORDER_SUCCESS,
} from 'features/dashboard/redux/types';
import { InputOrder } from 'features/dashboard/ts/InputOrder';
import { BulkEmailVerificationType, OrderSummary } from 'features/dashboard/ts/OrderSummary';

export interface OrdersState {
  isLoading: boolean;
  isOrderCreated: boolean;
  orderSummary?: OrderSummary[] | null;
  orders?: InputOrder[] | null;
  isBulkUploaded?: boolean;
  isBulkEmailValidationLoading?: boolean;
  bulkEmailsValidation?: Array<BulkEmailVerificationType> | null;
  isBulkOrderProcessing?: boolean;
  error?: string | null;
}

export const INITIAL_STATE: OrdersState = {
  isLoading: false,
  isOrderCreated: false,
  orderSummary: null,
  orders: null,
  isBulkUploaded: false,
  isBulkEmailValidationLoading: false,
  bulkEmailsValidation: null,
  isBulkOrderProcessing: false,
  error: null,
};

export const orders: Reducer<OrdersState, DashboardActions> = (state = INITIAL_STATE, action): OrdersState => {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return INITIAL_STATE;
    case CLEAR_ORDERS_STATE:
      return INITIAL_STATE;
    case CREATE_ORDER_REQUEST:
      return {
        ...state,
        isLoading: true,
        isOrderCreated: false,
        error: null,
      };
    case CREATE_ORDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isOrderCreated: true,
        error: null,
      };
    case CREATE_ORDER_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        isOrderCreated: false,
        error,
      };
    }
    case CREATE_BULK_ORDER_REQUEST:
      return {
        ...state,
        isBulkOrderProcessing: true,
        error: null,
      };
    case CREATE_BULK_ORDER_SUCCESS:
      return {
        ...INITIAL_STATE,
      };
    case CREATE_BULK_ORDER_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        isBulkOrderProcessing: false,
        error,
      };
    }
    case UPLOAD_BULK_ORDER_REQUEST:
      return {
        ...state,
        isLoading: true,
        isBulkUploaded: false,
        isOrderCreated: false,
        error: null,
      };
    case UPLOAD_BULK_ORDER_SUCCESS:
      const { summary, orders } = action.payload;
      return {
        ...state,
        orders,
        orderSummary: summary,
        isLoading: false,
        isBulkUploaded: true,
        isOrderCreated: false,
        error: null,
      };
    case UPLOAD_BULK_ORDER_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        orderSummary: null,
        orders: null,
        isLoading: false,
        isBulkUploaded: false,
        isOrderCreated: false,
        error,
      };
    }
    case BULK_EMAIL_VALIDATION_REQUEST: {
      return {
        ...state,
        bulkEmailsValidation: null,
        isBulkEmailValidationLoading: true,
      };
    }
    case BULK_EMAIL_VALIDATION_SUCCESS: {
      return {
        ...state,
        bulkEmailsValidation: action.payload,
        isBulkEmailValidationLoading: false,
      };
    }
    case BULK_EMAIL_VALIDATION_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        bulkEmailsValidation: null,
        isBulkEmailValidationLoading: false,
        error,
      };
    }
    default: {
      return state;
    }
  }
};
